import React, { useCallback } from 'react';

import { Descendant } from 'slate';
import { ImageElement } from '@/typings/editor';
import style from './index.module.css';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';

export const ImageComponent = ({
  attributes,
  children,
  element,
}: {
  attributes: any;
  children?: Descendant[];
  element: ImageElement;
}) => {
  const handlePreview = useCallback(() => {
    const viewer = new Viewer(document.getElementById('root')!, {
      inline: false,
      movable: false,
      toolbar: {
        zoomIn: 1,
        zoomOut: 1,
      },
      title: false,
      navbar: false,
      keyboard: true,
      viewed() {
        viewer.zoomTo(1);
      },
    });
  }, []);
  return (
    <div {...attributes} className={style.imageElement}>
      {children}
      <div contentEditable={false}>
        <img src={element.url} alt="" className={style.image} onClick={handlePreview} />
      </div>
    </div>
  );
};
